import React from "react";
import ModalComponent from "./Modal";
import { Typography, Box, Button, Stack } from "@mui/material";

const FinishAppModal = ({ openModal, questionnaires, setOpenModal, handleFinishApp }) => {
  const handleClose = () => {
    setOpenModal(false);
  };

  const buttonSx = {
    fontSize: {
      xs: "0.75rem",
      sm: "0.8125rem",
      md: "0.875rem",
    },
    px: {
      xs: 1.5,
      sm: 2,
    },
    py: {
      xs: 0.75,
      sm: 1,
    },
    minHeight: {
      xs: 36,
      sm: 40,
    },
    lineHeight: 1.2,
    textTransform: "none",
    whiteSpace: "normal",
    textAlign: "center",
  };

  return (
    <ModalComponent open={openModal} handleClose={handleClose} width="min(92vw, 520px)">
      <Box
        sx={{
          width: "100%",
          maxHeight: "calc(100vh - 64px)",
          overflowY: "auto",
          px: {
            xs: 0.5,
            sm: 1,
          },
          py: {
            xs: 0.5,
            sm: 1,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: {
              xs: 1,
              sm: 1.5,
            },
            mb: {
              xs: 2,
              sm: 3,
            },
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1.15rem",
                md: "1.35rem",
              },
              lineHeight: 1.25,
              fontWeight: 600,
              color: "text.primary",
              overflowWrap: "anywhere",
            }}
          >
            ¿Está seguro de que desea terminar la fase de aplicación?
          </Typography>

          {questionnaires > 0 && (
            <Typography
              component="p"
              sx={{
                fontSize: {
                  xs: "0.85rem",
                  sm: "0.95rem",
                  md: "1.05rem",
                },
                lineHeight: 1.35,
                fontWeight: 600,
                color: "error.main",
                overflowWrap: "anywhere",
              }}
            >
              ¡Tiene {questionnaires} cuestionarios pendientes por resolver!
            </Typography>
          )}

          <Typography
            component="p"
            sx={{
              fontSize: {
                xs: "0.82rem",
                sm: "0.9rem",
                md: "1rem",
              },
              lineHeight: 1.45,
              color: "text.secondary",
              overflowWrap: "anywhere",
            }}
          >
            Si termina, no podrá volver a ingresar.
          </Typography>
        </Box>

        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={{
            xs: 1,
            sm: 1.5,
          }}
          justifyContent="center"
          sx={{
            width: "100%",
            "& .MuiButton-root": {
              width: {
                xs: "100%",
                sm: "auto",
              },
            },
          }}
        >
          <Button variant="contained" onClick={handleFinishApp} sx={buttonSx}>
            Sí, terminar
          </Button>

          <Button variant="outlined" onClick={handleClose} sx={buttonSx}>
            Cancelar
          </Button>
        </Stack>
      </Box>
    </ModalComponent>
  );
};

export default FinishAppModal;
